import Vue from 'vue';

export function getQa (qa, state) {
    if (state) {
        let stateSelectors = '';
        stateSelectors = Object.keys(state).map(key => `[data-qa*="${key}:${state[key]}"]`).join('');
        return `[data-qa*="${qa} "]${stateSelectors}`;
    } else {
        return `[data-qa="${qa}"]`;
    }
}

export function $setQa (qa, state) {
    let stateSelectors = '';
    if (state) {
        stateSelectors = Object.keys(state).map(key => `${key}:${state[key]}`).join(' ');
    }

    return `${qa} ${stateSelectors}`;
}

Vue.mixin({
    methods: {
        $setQa,
    },
});
